<template>
  <kst-table input-mode :data="emailList">
    <b-table-column
      v-slot="{ column, row }"
      field="Email"
      :label="LowStockEmailCatalog.Email.Label"
    >
      <kst-output error-off field-only
        :field="column.field" :data="row" :catalog="LowStockEmailCatalog"
      />
    </b-table-column>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import Model from "../CpModel.js";
import LowStockEmailCatalog from "../CpLowStockEmailCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    emailList: Array
  },
  data: () => ({
    Model: Model,
    LowStockEmailCatalog: LowStockEmailCatalog
  })
}
</script>